import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LicenseExpirationNotifications from './LicenseExpirationNotifications';
import LicenseBlocker from './LicenseBlocker';

const LicenseManager = ({ user, children }) => {
  const { t } = useTranslation();
  const [licenseStatus, setLicenseStatus] = useState(null);
  const [isBlocked, setIsBlocked] = useState(false);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
    if (user && !user.isSuperAdmin) {
      checkLicenseStatus();
      // Vérifier périodiquement le statut
      const interval = setInterval(checkLicenseStatus, 2 * 60 * 1000); // Chaque 2 minutes
      return () => clearInterval(interval);
    } else {
      setLoading(false);
    }
  }, [user]);

  const checkLicenseStatus = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/license/my-license`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setLicenseStatus(data);
        
        // Déterminer si on doit bloquer l'application
        const shouldBlock = !data.hasLicense || data.license?.isExpired;
        setIsBlocked(shouldBlock);
      } else {
        // En cas d'erreur API, ne pas bloquer mais signaler
        console.warn('Impossible de vérifier la licence, accès autorisé par défaut');
        setIsBlocked(false);
      }
    } catch (error) {
      console.error('Erreur vérification licence:', error);
      // En cas d'erreur réseau, ne pas bloquer
      setIsBlocked(false);
    } finally {
      setLoading(false);
    }
  };

  const handleUnblock = () => {
    setIsBlocked(false);
    checkLicenseStatus(); // Revérifier le statut
  };

  // Si c'est un super admin, ne pas gérer les licences
  if (user?.isSuperAdmin || user?.role === 'super-admin') {
    return children;
  }

  // Pendant le chargement, afficher l'application normalement
  if (loading) {
    return children;
  }

  // Si bloqué, afficher le blocker
  if (isBlocked) {
    return <LicenseBlocker user={user} onUnblock={handleUnblock} />;
  }

  // Sinon, afficher l'application avec les notifications
  return (
    <>
      {children}
      <LicenseExpirationNotifications user={user} />
    </>
  );
};

export default LicenseManager;
